import { Link } from "react-router-dom"
import { TaskOrderCard } from "./TaskOrderCard"
import { useEffect, useState } from "react";
import { createTaskApi } from "../../api-helpers/TaskApiHelper";
import { TaskTypes } from "tasks-experience-client";
import Spinner from "../../components/Spinner";
import { UserContextHolder } from "../../auth/UserContextHolder";

export const Tasks = () => {
    const taskApi = createTaskApi();
    const [loading, setLoading] = useState(false);
    const [orderId, setOrderId] = useState<string>('');
    const [coachId, setCoachId] = useState<string>();

    useEffect(() => {
        UserContextHolder.addListener(() => {
            setCoachId(UserContextHolder.getUser()!.id);
        });
        const getOrderId = async () => {
            setLoading(true);
            setOrderId('');
            try {
                const response = await taskApi.taskControllerFindAllTaskTypes();
                const order = response.data.filter((type: TaskTypes) => type.name === 'Order');
                setOrderId(order[0]?.id);
            } catch (ex: any) {
            } finally {
                setLoading(false);
            }
        };
        getOrderId();
    }, []);
    
    return <>
        {loading && <Spinner />}
        <div className="sidebar h-100 d-flex flex-column">
            <div className="sidebar__content bg-blue-5 py-3 rounded-top">
                <div className='d-flex'>
                    <div className='flex-fill'><h3 className="text-primary fs-20 m-0">Tasks </h3></div>
                    <div className='ps-4'>
                        <Link to="/tasks" className="a-link a-underline text-info fs-12 text-nowrap">
                            View all
                        </Link>
                    </div>
                </div>
                <span className="d-block fs-11 text-light">Action items for patient care and management</span>
            </div>
            <div className="sidebar__content bg-blue-5 py-3">
                <div className="bg-white rounded p-0 sidebar__content-scroll-full">
                    { coachId ? <TaskOrderCard coachId={coachId} type="Task" scope="Global" orderId={orderId} /> : '' }
                </div>
            </div>
        </div>
    </>
}